module.exports = __webpack_public_path__ + "img/white_mysymptomsLogo.fe64c529.png";